module.exports = __webpack_public_path__ + "static/media/22.a9e3f555.png";